import React, { useEffect, useState, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormStep } from "@store/ui/formStepSlice";
import "@styles/pages/EventForm/step2/PreviewPage.scss";
import { Box, Typography, useMediaQuery } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Trans, useTranslation } from "react-i18next";
import { submitEventForm } from "@api/formApi";
import { resetEventForm } from "@store/eventForm/eventFormSlice";
import { toast } from "react-toastify";
import { setMemberInfoData } from "@store/member/memberInfoSlice";
import { getMemberProfile } from "@api/memberApi";
import { gaEvent } from "@utils/gaEvent";

// 📦 將活動資訊解析邏輯抽出為 function
const getDisplayWorkshopInfo = (submitData, workshopData, isChinese) => {
  const selectedEvent = workshopData.find(
    (e) => `${e.id}` === `${submitData?.event_name}`
  );

  const selectedLocation = selectedEvent?.workshop_location.find(
    (l) => l.address_hk_en === submitData?.event_location
  );

  const selectedDate = selectedLocation?.workshop_date.find(
    (d) => d.date === submitData?.event_date
  );

  const selectedTime = selectedDate?.workshop_time.find(
    (t) => `${t.workshop_detail_id}` === `${submitData?.event_time}`
  );

  return {
    event: isChinese ? selectedEvent?.title_hk : selectedEvent?.title_hk_en,
    location: isChinese
      ? selectedLocation?.address_hk
      : selectedLocation?.address_hk_en,
    date: selectedDate?.date,
    time: isChinese
      ? selectedTime?.time_slot_hk
      : selectedTime?.time_slot_hk_en,
  };
};

const PreviewPage = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  const submitData = useSelector((state) => state.eventForm.submitData);
  const workshopData = useSelector((state) => state.eventForm.workshopData);
  const eventInfo = useSelector((state) => state.eventForm.eventInfo);
  const eventGaType = useSelector((state) => state.eventForm.eventGaType);

  const isMobile = useMediaQuery("(max-width:768px)");
  const isChinese = i18n.language === "hk";

  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );
  const [isLoading, setIsLoading] = useState(false);

  const {
    event: displayEvent,
    location: displayLocation,
    date: displayDate,
    time: displayTime,
  } = getDisplayWorkshopInfo(submitData, workshopData, isChinese);

  const onSubmitData = () => {
    setIsLoading(true);
    eventGaType == "" &&
      gaEvent(
        "clubs_homepage",
        "smart_academy_register",
        "smart_academy_register",
        submitData.event_name
        // getValues("event_name")
      );

    eventGaType == "smart_academy" &&
      gaEvent(
        "clubs_smart_academy",
        "smart_academy_register",
        "smart_academy_register",
        submitData.event_name
        // getValues("event_name")
      );

    eventGaType == "event_registration" &&
      gaEvent(
        "clubs_experience",
        "experience_register",
        "experience__register_1",
        submitData.event_name
        // getValues("event_name")
      );
    console.log(submitData);
    const finalData = {
      workshop_detail_id: submitData.event_time,
      workshop_date: submitData.event_date,
      first_name: submitData.first_name,
      last_name: submitData.last_name,
      email: submitData.email,
      phone: submitData.select + submitData.mobile,
      lang: i18n.language,
      newsletter: submitData?.promotion == true ? 1 : 0,
      sua_id: "",
      action: submitData.action,
    };
    console.log(finalData);

    const fetchNewMemberProfile = async () => {
      setIsLoading(true);
      try {
        const res = await getMemberProfile();
        dispatch(setMemberInfoData(res.data.Data));

        setEdit(false);
      } catch (err) {
        console.error("更新失敗", err);
      } finally {
        setIsLoading(false);
      }
    };

    const postEventForm = async () => {
      try {
        const res = await submitEventForm(finalData);
        const statusCode = res.data.StatusCode;
        console.log(res);
        console.log(statusCode);

        setIsLoading(false);
        switch (statusCode) {
          case 200:
            toast.success(
              t("status_message:status_code_200_registration_form")
            );
            memberInfoData && fetchNewMemberProfile();
            dispatch(resetEventForm());
            dispatch(setFormStep({ formKey: "eventForm", step: 2 }));
            break;
          case 201:
            toast.success(t("status_message:status_code_201"));
            memberInfoData && fetchNewMemberProfile();
            dispatch(resetEventForm());
            dispatch(setFormStep({ formKey: "eventForm", step: 3 }));
            break;
          case 301:
            toast.error(t("status_message:status_code_301"));
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }));
            break;
          case 302:
            toast.error(t("form:status_message:status_code_302"));
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }));
            break;
          case 500:
            toast.error(t("form:status_message:status_code_500"));
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }));
            break;
          case 701:
            toast.error(t("form:status_message:status_code_701"));
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }));
            break;
          case 702:
            toast.error(t("form:status_message:status_code_702"));
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }));
            break;
          case 703:
            toast.error(t("form:status_message:status_code_703"));
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }));
            break;
          case 704:
            toast.error(t("form:status_message:status_code_704"));
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }));
            break;
        }
      } catch (err) {
        console.error(err);
      }
    };

    postEventForm();
  };
  return (
    <Box className="preview-page-container">
      <Typography className="confirm-text">
        <Trans i18nKey="form:preview_page_confirm_text" />
      </Typography>
      <Box className="row-container">
        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:last_name" />
          </Typography>
          <Typography className="data">
            {submitData.last_name || "-"}
          </Typography>
        </Box>

        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:first_name" />
          </Typography>
          <Typography className="data">
            {submitData.first_name || "-"}
          </Typography>
        </Box>
      </Box>
      <Box className="row-container">
        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:mobile_number_preview" />
          </Typography>
          <Typography className="data">
            {submitData.phone
              ? submitData.phone
              : submitData.select + submitData.mobile || "-"}
          </Typography>
        </Box>

        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:email_address" />
          </Typography>
          <Typography className="data">{submitData.email || "-"}</Typography>
        </Box>
      </Box>
      <Box className="row-container">
        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:event_name" />
          </Typography>
          <Typography className="data">{displayEvent || "-"}</Typography>
        </Box>

        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:event_location" />
          </Typography>
          <Typography className="data">{displayLocation || "-"}</Typography>
        </Box>
      </Box>
      <Box className="row-container">
        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:event_date" />
          </Typography>
          <Typography className="data">{displayDate || "-"}</Typography>
        </Box>

        <Box className="field-container">
          <Typography className="label">
            <Trans i18nKey="form:event_time" />
          </Typography>
          <Typography className="data">{displayTime || "-"}</Typography>
        </Box>
      </Box>
      <Box className="button-container">
        <LoadingButton
          disableElevation
          disableRipple
          className="button"
          onClick={() =>
            dispatch(setFormStep({ formKey: "eventForm", step: 0 }))
          }
          disabled={isLoading}
          loading={isLoading}
        >
          <Trans i18nKey="form:prev_button"></Trans>
        </LoadingButton>
        <LoadingButton
          className="loading-button"
          onClick={() => onSubmitData()}
          disabled={isLoading}
          loading={isLoading}
        >
          <Trans i18nKey="form:submit_button"></Trans>
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default PreviewPage;
